import {
  SetDefaultData,
  FetchLayerRequest,
  UpdateField,
  UpdateLayerRequest,
  UploadLayerFileRequest,
} from '../layer.actions'
import { getUpdateLayerState } from '../layer.selectors'
import Validator from '@shared/validatorjs/src/validator'
import { ActivatedRoute } from '@angular/router'
import { Store, select } from '@ngrx/store'
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  QueryList,
  ViewChildren,
} from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Subscription } from 'rxjs'
import { Map, fromJS } from 'immutable'

@Component({
  selector: 'app-update-layer',
  templateUrl: './update-layer.component.html',
  styleUrls: ['./update-layer.component.css'],
})
export class UpdateLayerComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  private state$: Subscription
  public isLoading: boolean
  public layerId: number
  public uploading: boolean
  public features: any[]
  public rowFieldChanged = false
  public forceUpdate = false
  public previewVisible = false

  constructor(public store: Store<any>, private route: ActivatedRoute) {
    super()
  }

  ngOnInit() {
    this.layerId = parseInt(this.route.snapshot.paramMap.get('id'))
    this.store.dispatch<any>(new SetDefaultData('updateLayer'))
    this.state$ = this.store
      .pipe(select(getUpdateLayerState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
        this.uploading = state.get('isUploading')

        if (!this.rowFieldChanged || this.forceUpdate) {
          this.features = this.state.getIn(['data', 'features'])
            ? (this.state.getIn(['data', 'features']) as any).toJS()
            : []

          this.forceUpdate = false
        }

        this.rowFieldChanged = false
      })

    this.store.dispatch<any>(new FetchLayerRequest(this.layerId))
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
  }

  get tableRows() {
    const features = this.features

    if (this.features && this.features.length) {
      const data = []

      features.forEach((row: any) => {
        data.push(row)
      })

      return data
    }

    return []
  }

  get tableColumns() {
    const features = this.state.getIn(['data', 'features']) as any

    if (features && features.size) {
      const firstFeature = features.get(0).toJS()
      const columns = Object.keys(firstFeature.attributes)

      columns.push('Label')
      columns.push('Value')

      return columns
    }

    return features === undefined ? undefined : []
  }

  get tableColumnNames() {
    const features = this.state.getIn(['data', 'features']) as any

    if (features && features.size) {
      const firstFeature = features.get(0).toJS()
      const columns = Object.keys(firstFeature.attributes)

      return columns
    }

    return []
  }

  public fillFields(e: any, field: string) {
    const data = (this.state.getIn(['data', 'features']) as any)
      .toJS()
      .map((feature: any) => {
        feature[field] = feature.attributes[e.target.value]

        return feature
      })

    this.store.dispatch(
      new UpdateField('features', fromJS(data), 'updateLayer.data'),
    )
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(
        name || e.target.name,
        e.target.name === 'file'
          ? e.target.files[0]
          : e?.target
          ? e.target.value
          : e,
        'updateLayer.data',
      ),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        'updateLayer',
      ),
    )
  }

  validation() {
    const data = this.state.get('data')
    let rules: any = {
      calculation: 'required',
      delivery: 'required',
      name: 'required',

      'features.*.value': 'numeric',
    }

    if (this.tableRows.length) {
      rules = { ...rules, idAttr: 'required' }
    }

    const validator = new Validator(data.toJS(), rules)

    validator.setAttributeNames({
      idAttr: 'id attribute',
    })

    return validator
  }

  public handleRowFieldChange(e: any, index: number) {
    this.rowFieldChanged = true

    this.store.dispatch(
      new UpdateField(
        e.target.name,
        e.target.name === 'value' ? parseFloat(e.target.value) : e.target.value,
        `updateLayer.data.features.${index}`,
      ),
    )
  }

  public toggle(name: string, e: any) {
    this.store.dispatch(
      new UpdateField(name, e.target.checked, 'updateLayer.data'),
    )
  }

  upload() {
    if (this.state.getIn(['data', 'file'])) {
      this.store.dispatch(
        new UploadLayerFileRequest(
          this.layerId,
          this.state.getIn(['data', 'file']),
        ),
      )
    }
  }

  public onSubmit(e: Event): void {
    this.forceUpdate = true

    e.preventDefault()

    const validation = this.validation()
    let payload = this.state.get('data').delete('file').toJS()

    if (validation.passes()) {
      this.store.dispatch(new UpdateLayerRequest(this.layerId, payload))
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          'updateLayer',
        ),
      )
    }
  }
}
